import axios from 'axios';
import loadImage from 'blueimp-load-image';
import thisAuth from './auth';
import router from '../router';

// create axios instance
const service = axios.create({
  timeout: 60000,  
  withCredentials: true,
});

let totalR = 0;
let isRefreshing = false;
const refreshSubscribers = [];

// axios request interceptor
service.interceptors.request.use(
  (config) => {
    const accessToken = thisAuth.getLocalAccessToken();
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    if (!!window.ActiveXObject || "ActiveXObject" in window) {
      config.url = config.url + '?date=' + new Date().getTime();
    }
    return config;
  },
  (error) => {
    // handle request error
    return Promise.reject(error);
  },
);

// axios response interceptor
service.interceptors.response.use(
  response => response,
  (error) => {
    const errorURL = router.currentRoute.fullPath;
    if (error.message === 'Network Error') {
      router.push({
        path: '/error',
        query: {
          message: error.message,
          redirectedFrom: errorURL
        },
      });
    } else if (error.code === 'ECONNABORTED') {
      router.push({
        path: '/error',
        query: {
          message: 408,
          redirectedFrom: errorURL
        },
      });
    } else if (error.response !== undefined) {
      if (error.response.status === 408) {
        router.push({
          path: '/error',
          query: {
            message: 408,
            redirectedFrom: errorURL
          },
        });
      }
      const { config, response: { status, statusText } } = error;
      const originalRequest = config;
      const currentRoute = router.currentRoute;
      const isExternal = currentRoute.meta.external;

      // Refresh token
      if (status === 401 && statusText === 'Unauthorized') {
        if (!isRefreshing) {
          isRefreshing = true;
          const refreshToken = thisAuth.getLocalRefreshToken();

          if (refreshToken) {
            if (!isExternal) {
              thisAuth.getRefreshAccessToken(refreshToken).then((model) => {
                isRefreshing = false;
                thisAuth.setLocalAccessToken(model);
                if (totalR < 3) {
                  onRefreshed(model.accessToken);
                  totalR += 1;
                } else {
                  console.log('Please refresh page.');
                }
              }).catch((errorRefresh) => {
                console.log(errorRefresh);
                thisAuth.goLogin();
              });
            } else {
              thisAuth.getRefreshAccessTokenExternal(refreshToken).then((model) => {
                isRefreshing = false;
                thisAuth.setLocalAccessToken(model);
              }).catch((errorRefresh) => {
                console.log(errorRefresh);
                router.push({
                  path: '/external/login',
                  query: {
                    mpWorkAppId: config.MPWORKAPPID,
                    message: errorRefresh,
                    redirect_uri: currentRoute.path
                  },
                });
              });
            }
          }
        }
        const retryOrigReq = new Promise((resolve) => {
          subscribeTokenRefresh((access_token) => {
            resolve(service(originalRequest));
          });
        });
        return retryOrigReq;
      }
    }

    return Promise.reject(error);
  },
);


function subscribeTokenRefresh(cb) {
  refreshSubscribers.push(cb);
}

function onRefreshed(token) {
  refreshSubscribers.map(cb => cb(token));
}

function checkNested(obj) {
  const args = Array.prototype.slice.call(arguments, 1);

  for (let i = 0; i < args.length; i++) {
    if (!obj || !obj.hasOwnProperty(args[i])) {
      return false;
    }
    obj = obj[args[i]];
  }
  return true;
}
function getUrlKey(name) {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null;
}
class cokeStorage {
  setItem(key, value) {
    if (sessionStorage.getItem('isExternal') !== 'undefined') {
      return localStorage.setItem(key, value);
    } else {
      return sessionStorage.setItem(key, value);
    }
  }
  getItem(key) {
    if (sessionStorage.getItem('isExternal') !== 'undefined') {
      return localStorage.getItem(key);
    } else {
      return sessionStorage.getItem(key);
    }
  }
  removeItem(key) {
    if (sessionStorage.getItem('isExternal') !== 'undefined') {
      return localStorage.removeItem(key);
    } else {
      return sessionStorage.removeItem(key);
    }
  }
}
export default new cokeStorage();

// http://emailregex.com/
// https://github.com/VincentSit/ChinaMobilePhoneNumberRegex
const regExp = {
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  phone: /^1[0123456789]\d{9}$/,
};

const correctImgOrientation = (imgFile, imgHandler) => {
  loadImage(
    imgFile,
    (canvas) => {
      const dataURL = canvas.toDataURL('image/jpeg', 0.5); // this convert canvas to base64 format
      imgHandler(dataURL);
    },
    { orientation: true },
  );
};

const scrollErrMsgToView = (wrapperEleClass) => {
  const errorMsgLabel = document.querySelectorAll(`${wrapperEleClass || 'body'} .error-msg`);
  setTimeout(() => {
    let scrolled = false;
    errorMsgLabel.forEach((ele) => {
      if (!scrolled && ele.style.display !== 'none') {
        ele.previousElementSibling.scrollIntoView();
        scrolled = !scrolled;
      }
    });
  }, 300); // v-show's toggle show and hide may have a duration
};

export {
  service as request,
  checkNested,
  regExp,
  getUrlKey,
  correctImgOrientation,
  scrollErrMsgToView,
};
